import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { GridRow, Column, MoneyField } from '../../common';

const FECSection6d = ({ q6dColA, q6dColB }) => {
  return (
    <Fragment>
      <GridRow>
        <Column md={4} classNames="sub-question">
          <p>
            (d) Subtotal (add Lines 6(b) and
            <br />
            6(c) for Column A and Lines
            <br />
            6(a) and 6(c) for Column B
          </p>
        </Column>
        <Column md={4} classNames="entry-row">
          <MoneyField
            disabled
            value={q6dColA || 0}
          />
        </Column>
        <Column md={4} classNames="entry-row">
          <MoneyField disabled value={q6dColB || 0} />
        </Column>
      </GridRow>
    </Fragment>
  );
};

FECSection6d.propTypes = {
  q6dColA: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  q6dColB: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FECSection6d;
